// extracted by mini-css-extract-plugin
export default {"description":"ErrorMessage_description__E1y01","content":"ErrorMessage_content__Rrzuf","title":"ErrorMessage_title__g4sPZ","button":"ErrorMessage_button__NXoj0"};